import React from 'react';
import Link from 'next/link';
import { Typography } from '@tmap/mmm-style-guide/src/Typography';
import { Button } from '@tmap/mmm-style-guide/src/Button';
import { Grid } from '@tmap/mmm-style-guide/src/Grid';
import { ExpandMore } from '@tmap/mmm-style-guide/src/Icon';
import { Accordion } from '@tmap/mmm-style-guide/src/Accordion';
import { AccordionDetails } from '@tmap/mmm-style-guide/src/AccordionDetails';
import { AccordionSummary } from '@tmap/mmm-style-guide/src/AccordionSummary';
import { styled } from '@tmap/mmm-style-guide/src/styled';

const FaqAccordion = styled(Accordion)(({ theme }) => ({
  paddingTop: theme.spacing(1),
  paddingBottom: theme.spacing(1),
  '&.Mui-expanded': {
    background: theme.palette.grey[50],
  },
  '&.Mui-expanded .MuiAccordionSummary-root .MuiTypography-root': {
    fontWeight: 600,
  },
  '&:not(:first-of-type).Mui-expanded:before, &:not(:last-of-type).Mui-expanded:after': {
    opacity: 1,
    display: 'block !important',
  },
}));

function FaqsBlock(props) {
  const {
    leadCopy,
    subLeadCopy,
    contactLink,
    faqs,
    ...otherProps
  } = props;
  return (
    <Grid container spacing={{ xs: 6, md: 11 }} {...otherProps}>
      <Grid item xs={12} md={4.5}>
        <Typography variant='h4' fontWeight={700} mb={2}>
          {leadCopy}
        </Typography>
        <Typography variant='body1' color='textSecondary' mb={4}>
          {subLeadCopy}
        </Typography>
        {contactLink && (
          <Button href={contactLink} variant='contained' color='primary' fullWidth>
            Contact Us
          </Button>
        )}
      </Grid>
      <Grid item xs={12} md={7.5}>
        {faqs.map((faq, i) => (
          <FaqAccordion disableGutters elevation={0} key={faq._key || `${faq._id || 'faq'}-${i}`}>
            <AccordionSummary expandIcon={<ExpandMore />}>
              <Typography variant='body2'>{faq.question}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography variant='body2' color='textSecondary' whiteSpace='pre-line'>{faq.answer}</Typography>
              {faq.infoText && faq.infoLink && (
                <Link href={faq.infoLink} target='_blank'>
                  <Button
                    color='info'
                    sx={{
                      marginTop: 0.25,
                      marginLeft: -0.5,
                      marginBottom: -0.5,
                      display: 'inline-block',
                    }}
                  >
                    {faq.infoText}
                  </Button>
                </Link>
              )}
            </AccordionDetails>
          </FaqAccordion>
        ))}
      </Grid>
    </Grid>
  );
}

export default FaqsBlock;
